var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5833 12.7725C20.0417 12.9134 19.5 13 18.9583 13C17.379 12.9972 15.8651 12.3685 14.7483 11.2517C13.6315 10.1349 13.0029 8.62106 13 7.04169C13 5.44919 13.6283 4.00836 14.625 2.93586C14.4284 2.69486 14.1805 2.50076 13.8994 2.3677C13.6183 2.23464 13.311 2.16597 13 2.16669C11.8083 2.16669 10.8333 3.14169 10.8333 4.33336V4.64753C7.61583 5.60086 5.41667 8.55836 5.41667 11.9167V18.4167L3.25 20.5834V21.6667H22.75V20.5834L20.5833 18.4167V12.7725ZM13 24.9167C14.2025 24.9167 15.1667 23.9525 15.1667 22.75H10.8333C10.8333 23.3247 11.0616 23.8758 11.4679 24.2821C11.8743 24.6884 12.4254 24.9167 13 24.9167Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9583 10.8333C21.0491 10.8333 22.75 9.1325 22.75 7.04167C22.75 4.95083 21.0491 3.25 18.9583 3.25C16.8675 3.25 15.1666 4.95083 15.1666 7.04167C15.1666 9.1325 16.8675 10.8333 18.9583 10.8333Z",
    fill: "#DA1E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2c50c3d770746e9305077355429b13c8.svg";
export { ForwardRef as ReactComponent };